/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

// MAIN COLORS - VUESAX THEME COLORS
export const colors = {
  primary : '#DC3040',
  success : '#438E44',
  danger  : '#f50000',
  warning : '#FF9F43',
  dark    : '#1E1E1E',
  blue1: '#000233',
  blue2: '#000366',
  blue3: '#000599',
  blue4: '#0007cc',
  blue5: '#0008ff',
  blue6: '#333aff',
  blue7: '#666bff',
  blue8: '#999cff',
  blue9: '#ccceff',
  red1:'#330000',
  red2:'#660000',
  red3:'#990000',
  red4:'#cc0000',
  red5:'#ff0000',
  red6:'#ff3333',
  red7:'#ff6666',
  red8:'#ff9999',
  red9:'#ffcccc',
  yelow1:'#333300',
  yelow2:'#666600',
  yelow3:'#999900',
  yelow4:'#cccc00',
  yelow5:'#ffff00',
  yelow6:'#ffff33',
  yelow7:'#ffff66',
  yelow8:'#ffff99',
  yelow9:'#ffffcc',
  orange1:'#331f00',
  orange2:'#663d00',
  orange3:'#995c00',
  orange4:'#cc7a00',
  orange5:'#ff9900',
  orange6:'#ffad33',
  orange7:'#ffc266',
  orange8:'#ffd699',
  orange9:'#ffebcc',
  purple1: '#290033',
  purple2:'#520066',
  purple3:'#7a0099',
  purple4:'#a300cc',
  purple5:'#cc00ff',
  purple6:'#d633ff',
  purple7:'#e066ff',
  purple8:'#eb99ff',
  purple9:'#f5ccff',
  green1:'#003300',
  green2:'#006600',
  green3:'#009900',
  green4:'#00cc00',
  green5:'#00ff00',
  green6:'#33ff33',
  green7:'#66ff66',
  green8:'#99ff99',
  green9:'#ccffcc',
  white1:'#ebeef1',
  white2:'#d4d6d9',
  white3:'#bcbec1',
  white4:'#a5a7a9',
  white5:'#8d8f91',
  white6:'#767779',
  white7:'#5e5f60',
  white8:'#464748',
  white9:'#2f3030',
}

// CONFIGS
const themeConfig = {
  disableCustomizer : false,       // options[Boolean] : true, false(default)
  disableThemeTour  : true,        // options[Boolean] : true, false(default)
  footerType        : 'sticky',    // options[String]  : static(default) / sticky / hidden
  hideScrollToTop   : false,       // options[Boolean] : true, false(default)
  mainLayoutType    : 'vertical',  // options[String]  : vertical(default) / horizontal
  navbarColor       : 'primary',      // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType        : 'sticky',  // options[String]  : floating(default) / static / sticky / hidden
  routerTransition  : 'slide-fade', // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
  rtl               : false,       // options[Boolean] : true, false(default)
  sidebarCollapsed  : false,       // options[Boolean] : true, false(default)
  theme             : 'light',     // options[String]  : "light"(default), "dark", "semi-dark"

  // Not required yet - WIP
  userInfoLocalStorageKey: 'userInfo'

  // NOTE: themeTour will be disabled in screens < 1200. Please refer docs for more info.
}

import Vue from 'vue'
import Vuesax from 'vuesax'
Vue.use(Vuesax, { theme:{ colors }, rtl: themeConfig.rtl })

export default themeConfig
